import React, { useState } from 'react';
import MobileHeader from './MobileHeader';
import MobileNav from './MobileNav';
import MobileCreateSheet from './MobileCreateSheet';

/**
 * MobileLayout — wraps every page on mobile with:
 * - Fixed top header (56px)
 * - Fixed bottom nav (56px + safe-area)
 * - "Create" slide-up sheet
 *
 * On md+ screens this renders nothing extra (desktop layout handles itself).
 */
const MobileLayout = ({ children }) => {
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <>
      <MobileHeader />

      {/* Wrap children once, and only apply the padding on mobile screens */}
      <div className="pt-[56px] md:pt-0">
        {children}
      </div>

      <MobileNav onCreate={() => setCreateOpen(true)} />

      {createOpen && (
        <MobileCreateSheet onClose={() => setCreateOpen(false)} />
      )}
    </>
  );
};

export default MobileLayout;
